const API_BASE = process.env.REACT_APP_API_URL || '';

export const api = {
  async get(path) {
    const res = await fetch(`${API_BASE}${path}`);
    if (!res.ok) throw new Error(`API error: ${res.status}`);
    return res.json();
  },

  getProducts(params = {}) {
    const qs = new URLSearchParams();
    if (params.category && params.category !== 'all') qs.set('category', params.category);
    if (params.sort) qs.set('sort', params.sort);
    if (params.search) qs.set('search', params.search);
    if (params.home) qs.set('home', params.home);
    const query = qs.toString();
    return this.get(`/api/products${query ? '?' + query : ''}`);
  },

  getProduct(id) {
    return this.get(`/api/products/${id}`);
  },

  getProductBySlug(slug) {
    return this.get(`/api/products/slug/${slug}`);
  },

  getCategories() {
    return this.get('/api/categories');
  },

  getReviews(productId) {
    return this.get(`/api/reviews?productId=${productId}`);
  },

  getSettings() {
    return this.get('/api/settings');
  },

  getPosts(tag) {
    const params = tag ? `?tag=${encodeURIComponent(tag)}` : '';
    return this.get(`/api/posts${params}`);
  },

  getPost(slug) {
    return this.get(`/api/posts/slug/${slug}`);
  },

  getSeoPageBySlug(slug) {
    return this.get(`/api/seo/slug/${slug}`);
  },

  getSeoReviews(seoPageId) {
    return this.get(`/api/seo-reviews/page/${seoPageId}`);
  },

  submitSeoReview(data) {
    return apiFetch('/api/seo-reviews', {
      method: 'POST',
      body: data,
    });
  },

  imageUrl(url) {
    if (!url) return '';
    if (url.startsWith('http')) return url;
    return `${API_BASE}${url}`;
  },

  trackEvent(targetType, targetId, eventType) {
    return trackEvent(targetType, targetId, eventType);
  }
};

export default api;

let lastTracked = null;

export function getTrafficSource() {
  const urlParams = new URLSearchParams(window.location.search);
  const referrer = document.referrer ? document.referrer.toLowerCase() : '';
  const hasGclid = urlParams.has('gclid') || urlParams.has('gbraid') || urlParams.has('wbraid');
  const hasFbclid = urlParams.has('fbclid');

  if (hasGclid || referrer.includes('googleadservices.com') || (referrer.includes('google.') && referrer.includes('aclk'))) {
    return 'ads';
  }
  if (referrer.includes('google.')) {
    return 'seo';
  }
  if (referrer.includes('facebook.com') || referrer.includes('fb.com') || hasFbclid) {
    return 'facebook';
  }
  if (!referrer || referrer.includes(window.location.hostname)) {
    return 'direct';
  }
  return 'other';
}

export function trackEvent(targetType, targetId, eventType) {
  if (!targetType || !targetId || !eventType) return;

  if (eventType === 'view') {
    const key = `${targetType}-${targetId}`;
    if (lastTracked === key) return;
    lastTracked = key;
  }

  const source = getTrafficSource();
  apiFetch('/api/stats/track', {
    method: 'POST',
    body: { targetType, targetId: Number(targetId), source, eventType }
  }).catch(err => console.error('Tracking error:', err));
}

export async function apiFetch(path, options = {}) {
  const { method = 'GET', body, ...rest } = options;
  const config = { method, ...rest };

  if (body) {
    config.headers = { 'Content-Type': 'application/json', ...config.headers };
    config.body = JSON.stringify(body);
  }

  const res = await fetch(`${API_BASE}${path}`, config);
  if (!res.ok) throw new Error(`API error: ${res.status}`);
  return res.json();
}